
import React from 'react'
import { LoginForm } from '../components/Login/LoginForm'
import '../css/Login.css';

export const LoginPage = () => {
    return <LoginForm />
   
}
